module.exports = __webpack_public_path__ + "static/img/aepic-10.f7699bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-10.jpg
// module id = atNm
// module chunks = 52